module.exports = {
  VEHICLE: 'vehicle',
  OFFER: 'offer',
  SHIPPING: 'shipping',
};
